import { writable } from "svelte/store";

export let answered=writable({})